import { InspectorControls } from "@wordpress/block-editor";
import { createHigherOrderComponent } from "@wordpress/compose";
import React from "react";
import VisibilityControls from "../components/VisibilityControls";

const withVisibilityControls = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        const { attributes, setAttributes } = props;

        // Sprawdź czy blok ma już zdefiniowane atrybuty widoczności
        if (!attributes.hideBreakpoint) {
            return <BlockEdit {...props} />;
        }

        // Aktualizacja klas widoczności
        React.useEffect(() => {
            const currentClasses = attributes.className
                ? attributes.className.split(" ")
                : [];
            const visibilityClasses = [
                "hide-desktop",
                "hide-tablet",
                "hide-phone",
            ];

            // Sprawdź, czy klasy się faktycznie zmieniły
            const hasDesktop = currentClasses.includes("hide-desktop");
            const hasTablet = currentClasses.includes("hide-tablet");
            const hasPhone = currentClasses.includes("hide-phone");

            if (
                hasDesktop === attributes.hideBreakpoint.desktop &&
                hasTablet === attributes.hideBreakpoint.tablet &&
                hasPhone === attributes.hideBreakpoint.phone
            ) {
                return; // Nie ma potrzeby aktualizacji
            }

            const cleanedClasses = currentClasses.filter(
                (cls) => !visibilityClasses.includes(cls)
            );

            const newClasses = [
                ...cleanedClasses,
                attributes.hideBreakpoint.desktop ? "hide-desktop" : "",
                attributes.hideBreakpoint.tablet ? "hide-tablet" : "",
                attributes.hideBreakpoint.phone ? "hide-phone" : "",
            ].filter(Boolean);

            setAttributes({
                className: newClasses.join(" ").trim(),
            });
        }, [attributes.hideBreakpoint]); // Usuń attributes.className z zależności

        return (
            <>
                <BlockEdit {...props} />
                <InspectorControls>
                    <VisibilityControls
                        attributes={attributes}
                        setAttributes={setAttributes}
                    />
                </InspectorControls>
            </>
        );
    };
}, "withVisibilityControls");

export default withVisibilityControls;
